module.exports = __webpack_public_path__ + "img/Structures-1-mobile.a5804585.png";